export async function fetchJson<T>(url: URL, timeout: number, options?: Pick<RequestInit, 'headers'> & {fetch?: typeof fetch}): Promise<T> {
    const response = await (options?.fetch ?? (globalThis.fetch ?? fetch))(url.href, {
        signal: AbortSignal.timeout(timeout),
        headers: options?.headers,
    });
    if (response.status !== 200) {
        throw new Error(`Failed to fetch ${url.href}: ${response.statusText}`);
    }
    try {
        return (await response.json()) as T;
    } catch {
        throw new Error('Failed to parse response');
    }
}
